<template>
   <sd-modal v-show="show">
      <div class="aword_alert" :class="type||'select'">
        <i class="close" @click="show = ''"></i>
        <div class="wrap">
          <div class="inner">
            <i class="icon"></i>
            <p>{{defContent}}</p>
            <ul v-if="type == 'select'">
              <li class="danger" @click="affirm">确认</li>
              <li class="ghost"  @click="cancel">取消</li>
            </ul>
            <ul v-else-if="type == 'error'">
              <li class="danger" @click="affirm">确认</li>
            </ul>
            <ul v-else>
              <li class="danger" @click="affirm">确认</li>
            </ul>
          </div>
        </div>
      </div>
    </sd-modal>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    import sdModal from './sdModal'
    export default {
        name:'sd-confirm',
        props: [],
        components: { sdModal },
        data () {
            return {
                show: false,
                type: '',
                title: '',
                content: '',
                fn: undefined,
            }
        },
        computed: {
            defContent() {
              if(this.content){
                return this.content;
              } else if(this.type == 'select') {
                return '确认操作？';
              } else if(this.type == 'error') {
                return '操作错误！';
              } else if(this.type == 'success'){
                return '操作成功！';
              }
            }
        },
        methods: {
            select(title,content,fn) {
              this.type = 'select';
              this.title = title;
              this.content = content;
              this.fn = fn;
              this.show = true;
            },
            success(content,fn) {
              this.type = 'success';
              this.title = '操作成功';
              this.content = content;
              this.fn = fn;
              this.show = true;
            },
            error(content,fn) {
              this.type = 'error';
              this.title = '操作失败';
              this.content = content;
              this.fn = fn;
              this.show = true;
            },
            affirm() {
              this.show = false;
              this.fn && this.fn();
              this.fn = undefined;
              this.$emit('on-affirm', this.data);
            },
            cancel() {
              this.show = false;
              this.fn = undefined;
              this.$emit('on-cancel', this.data);
            },

        },
        created(){
            
        }
    }
</script>

<style lang="scss">

  
</style>


// WEBPACK FOOTER //
// sdConfirm.vue?41649ab4